import { render, staticRenderFns } from "./ProgramCustomizationNavigator.vue?vue&type=template&id=12a9af3e&lang=pug&"
import script from "./ProgramCustomizationNavigator.vue?vue&type=script&lang=js&"
export * from "./ProgramCustomizationNavigator.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCustomizationNavigator.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports